import { getAxiosClient } from '~src/api';
import { getUser } from '~src/user';

export const fetchDefuntoCordogli = async () => {
  const httpClient = await getAxiosClient();
  const url = `${process.env.ANNUNCI_FUNEBRI_API_URL}/cordogli`;

  const options = {
    headers: { 'content-type': 'application/json' },
  };

  const { user } = await getUser();
  const orgId = user.org_pointer.objectId;

  const data = {};

  if (process.env.ENVIRONMENT === 'prod') {
    data.codice_impresa = orgId;
    data.codice_annuncio = window.editorConfig.annunciFunebri.objectId;
  } else {
    data.codice_impresa = 'sJ3KLlKt21';
    data.codice_annuncio = 'EeLbQOHG0P';
  }

  const method = 'POST';
  const response = await httpClient({
    url,
    method,
    data,
    options,
  });

  return response.data.cordogli;
};
